module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_add_term')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_days')))])]), _vm._v(" "), _vm._l((_vm.days), function(item, key) {
    return _c('span', {
      attrs: {
        "value": key
      }
    }, [(key % 3 === 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', [_c('input', {
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "id": key,
        "type": "Checkbox",
        "name": "key",
        "value": "key"
      },
      domProps: {
        "checked": _vm.isChecked(item.key)
      },
      on: {
        "click": function($event) {
          return _vm.onChangeCheckBoxDay(key, item.key)
        }
      }
    }), _vm._v("\n                                     "), _c('label', {
      staticStyle: {
        "color": "white",
        "font-size": "18px"
      },
      attrs: {
        "for": key
      }
    }, [_vm._v(_vm._s(item.value))]), _vm._v("   \n                                ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.trainingNumbers))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxTrainings),
      expression: "model.maxTrainings"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.trainingNumbers,
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.maxTrainings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxTrainings", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_time')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSelectedTime),
      expression: "currentSelectedTime"
    }],
    staticClass: "form-control input",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "placeholder": "HH:mm",
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.currentSelectedTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentSelectedTime = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ti-plus",
    staticStyle: {
      "font-size": "20px",
      "color": "white",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.addTime()
      }
    }
  })])])])]), _vm._v(" "), (_vm.model.startAt.length > 0) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.model.startAt), function(item) {
    return _c('div', [_c('b', [_vm._v(_vm._s(item) + "  ")]), _vm._v(" "), _c('i', {
      staticClass: "ti-trash",
      staticStyle: {
        "color": "#FF0000",
        "cursor": "pointer",
        "margin-right": "8px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTime(item)
        }
      }
    })])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_training_type_title')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingType),
      expression: "model.trainingType"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "trainingType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                                                " + _vm._s(item) + "\n                                            ")])
  }), 0)])])])]), _vm._v(" "), (_vm.showAddTrainerToSlot) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_name_for_partner')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainerOnSlot),
      expression: "model.trainerOnSlot"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "trainerOnSlot", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                  " + _vm._s("") + "\n                                ")]), _vm._v(" "), _vm._l((_vm.partners), function(item) {
    return _c('option', {
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisibleAddUserToTerm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showChoseUser()
      }
    }
  }, [_vm._v("+"), _c('i', {
    staticClass: "ti-user"
  }), _vm._v("  " + _vm._s(_vm.locale.t('label_term_add_user_to_term')) + "\n                            ")])])]), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.selectedUsers), function(selectedUser) {
    return _c('div', {
      staticClass: "form-group text-center"
    }, [_c('b', [_vm._v(_vm._s(selectedUser.name) + " " + _vm._s(selectedUser.surname) + " (" + _vm._s(selectedUser.username) + ")")]), _vm._v(" " + _vm._s(_vm.locale.t('label_term_user_will_be_added')) + " "), _c('i', {
      staticClass: "ti-trash",
      staticStyle: {
        "color": "#FF0000",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedUser(selectedUser)
        }
      }
    })])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.openTermsForCurrentWeek),
      expression: "model.openTermsForCurrentWeek"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "checkbox",
      "name": "isForCompany"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.openTermsForCurrentWeek) ? _vm._i(_vm.model.openTermsForCurrentWeek, null) > -1 : (_vm.model.openTermsForCurrentWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.openTermsForCurrentWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "openTermsForCurrentWeek", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "openTermsForCurrentWeek", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "openTermsForCurrentWeek", $$c)
        }
      }
    }
  }), _vm._v("\n                         "), _c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_open_terms_for_current_week')))]), _vm._v("   \n                        "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addTerm
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                                    ")])])])])], 2)])])])]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3272c277!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Term/Add/AddTerm.vue
// module id = 753
// module chunks = 0